import gql from 'graphql-tag'

export const BIOMARKERS = gql`
  query biomarkers {
    biomarkers {
      id
      name
      type
      synonyms
      units {
        unit
        synonyms
        conversion
      }
      range {
        type
        universal {
          normal
        }
        male {
          normal
        }
        female {
          normal
        }
        text
        link {
          anchor
          url
        }
      }
    }
  }
`

export const BIOMARKER_BY_ID = gql`
  query biomarkerById($id: ID!) {
    biomarkerById(id: $id) {
      id
      name
      code
      type
      synonyms
      common
      one_liner
      summary {
        description
        func
        cause
        influence
      }
      units {
        unit
        synonyms
        conversion
      }
      range {
        type
        universal {
          normal
          borderline
          deficient
        }
        male {
          normal
          borderline
          deficient
        }
        female {
          normal
          borderline
          deficient
        }
        text
        link {
          anchor
          url
        }
      }
    }
  }
`

export const DEFAULT_UNITS = gql`
  query defaultUnits {
    defaultUnits {
      unit
      synonyms
    }
  }
`

export const CATEGORY_CODES = gql`
  query categoryCodes {
    defaultCategories {
      index
      code
    }
  }
`

export const CATEGORIES = gql`
  query categories {
    categories {
      index
      name
      code
      description
      biomarkers {
        biomarker {
          id
          name
          code
          range {
            type
            universal {
              normal
              borderline
              deficient
            }
            male {
              normal
              borderline
              deficient
            }
            female {
              normal
              borderline
              deficient
            }
            text
            link {
              anchor
              url
            }
          }
          units {
            unit
            synonyms
            conversion
          }
        }
        results {
          date
          text
          quantity
          unit
        }
      }
    }
  }
`

export const VITAL_SIGNS = gql`
  query vitalSigns {
    vitalSigns {
      biomarker {
        id
        name
      }
      quantity
      unit
    }
  }
`

export const CREATE_BIOMARKER = gql`
  mutation createBiomarker($biomarkerCreate: BiomarkerInput!) {
    createBiomarker(biomarkerCreate: $biomarkerCreate) {
      name
      code
      type
      synonyms
      common
      one_liner
      summary {
        description
        func
        cause
        influence
      }
    }
  }
`

export const UPDATE_BIOMARKER = gql`
  mutation updateBiomarker($biomarkerUpdate: BiomarkerInput!) {
    updateBiomarker(biomarkerUpdate: $biomarkerUpdate) {
      id
      name
      code
      type
      synonyms
      common
      one_liner
      summary {
        description
        func
        cause
        influence
      }
    }
  }
`

export const DELETE_BIOMARKER = gql`
  mutation deleteBiomarker($id: ID!) {
    deleteBiomarker(id: $id) {
      id
    }
  }
`
